module.exports = __webpack_public_path__ + "images/green-nature-3-cb2c4d3bc7fa149816df5ca4f256329b.jpg";